import { useContext } from 'react'
import css from './proteinFunction.module.scss'
import { proteinNameNormalize } from "../../../utils/proteinNameNormalize";
import { downloadPdf } from "../../../utils/downloader";
import { AuthContext } from '../../../context/auth';


export const ProteinFunction = ({
    setSelectedProtein,
    proteinInfo,
    pathway
}) => {
    const { setNotification } = useContext(AuthContext)

    return (
        <div className={css.proteinDetails}>
            <div className={css.protein}>
                <>
                    <div className={`${css.row} ${css.backBtn}`}
                        onClick={() => setSelectedProtein(null)}
                    >
                        <span className={css.navBtn}><i className='fas fa-chevron-left'></i></span>
                        Return to Map
                    </div>
                    <div className={css.proteinHeader}>
                        <div className={css.leftCol}>
                            <h4>{proteinInfo?.name}</h4>
                        </div>
                        <div className={css.rightCol}>
                            <button onClick={() => setSelectedProtein(null)}><i className='far fa-times' /></button>
                        </div>
                    </div>
                    <div className={css.divider} />
                    <div className={css.proteinInfo}>
                        <p className={css.functionText} dangerouslySetInnerHTML={{ __html: proteinInfo?.function || '-' }} />
                    </div>
                    <div className={css.divider} />
                    <div className={css.references}>
                        <h4>References:</h4>
                        <div className={css.referencesList}>
                            {proteinInfo?.reference.filter((item) => item !== "").map((item, index) => {
                                return <a href={item.includes("https") ? item : `https://${item}`} target="_blank" key={index}>[{index + 1}]</a>
                            })}
                        </div>
                    </div>
                    <div className={css.divider} />
                    <p>© Copyright {new Date().getFullYear()} GMD12 LLC.</p>
                </>
            </div>
            <div className={css.btnContainer}>
                <button className={css.btn}
                    onClick={() => {
                        downloadPdf(`https://content.identifyn.com/proteins/${pathway}_${proteinNameNormalize(proteinInfo.name)}.pdf`, `${pathway}_${proteinNameNormalize(proteinInfo?.name)}.pdf`)
                    }}
                >Download PDF</button>
                <button className={`${css.btn} ${css.copyBtn}`}
                    onClick={() => {
                        navigator.clipboard.writeText(`https://content.identifyn.com/proteins/${pathway}_${proteinNameNormalize(proteinInfo?.name)}.pdf`)
                        setNotification({ type: "success", message: "Link copied" })
                    }}
                >Copy Link</button>
            </div>
        </div>
    )
}